/* eslint-disable eqeqeq */
/* eslint-disable func-names */

jQuery($ => {
  $('.news-index__load-more').click(function () {
    const button = $(this);
    const postContainer = $('.news-index__posts');

    const data = {
      action: 'loadmore',
      query: nine3.posts,
      page: nine3.current_page,
    };

    $.ajax({
      url: nine3.ajaxurl,
      data,
      type: 'POST',
      beforeSend() {
        $('body').addClass('is-loading');
      },
      success(results) {
        if (results) {
          postContainer.append(results);
          nine3.current_page++;
          if (nine3.current_page == nine3.max_page) {
            button.remove();
          }
          $('body').removeClass('is-loading');
        } else {
          button.remove();
        }
      },
    });
  });
});



// WEBPACK FOOTER //
// ./assets/js/src/load-more.js